/**
 * Color constants for the application
 * Import these colors when you need direct color values
 * For Material-UI components, use theme.palette properties instead
 */

export const colors = {
  primary: {
    main: "#008095",
    light: "#00A3BA",
    dark: "#006075",
    contrastText: "#ffffff",
  },
  secondary: {
    main: "#c6d30a", // Green
    light: "#D9E32F",
    dark: "#A8B308",
    contrastText: "#008095",
  },
  accent: {
    main: "#003A8F", // Blue (kept as custom color)
    light: "#004AB3",
    dark: "#002D6B",
    contrastText: "#ffffff",
  },
  background: {
    default: "#ffffff",
    light: "#f4f6f8",
  },
  text: {
    primary: "#000000",
    secondary: "#555555",
    disabled: "#999999",
  },
  common: {
    white: "#ffffff",
    black: "#000000",
  },
  // Named colors for easy reference
  aqua: "#008095",
  green: "#c6d30a",
  rating: {
    main: "#FFC107",
    light: "#FFD54F",
    dark: "#FFA000",
  },
  overlay: {
    dark: "rgba(0, 0, 0, 0.5)",
    medium: "rgba(0, 0, 0, 0.12)",
    light: "rgba(255, 255, 255, 0.85)",
    whiteLight: "rgba(255, 255, 255, 0.35)",                                          
    whiteMedium: "rgba(255, 255, 255, 0.15)",
    border: "rgba(255, 255, 255, 0.3)",
    shadow: "rgba(0, 0, 0, 0.35)",
     cardShadow: "0px 10px 30px rgba(0, 0, 0, 0.12)",
  },
  gradient: {
    darkOverlay: "linear-gradient(90deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.15) 60%)",
    lightOverlay: "linear-gradient(180deg, rgba(255,255,255,0.35), rgba(255,255,255,0.15))",
  },
};
